<template>
  <StackItemModal
      :dialog="{
         width: '700px'
      }"
      :sheet="{}"
      breakpoint="md"
      :actions="actions"
      v-bind="stackComponent.bind"
      v-on="listeners"
      :title="dialogTitle"
      @hide="onHide"
  >
    <q-resize-observer @resize="onResize"/>

    <div class="">
      <ScrollHorizontal
          :fader-right="true"
          :fader-left="true"
          :hover-scroll="true"
          fader-width="30px"
          class="c-scroll q-mb-md"
          style="width:calc(100vw - 36px)"
          v-if="benefitTypesComputed.length > 1"
      >
        <div>
          <ButtonsToggle
              :model-value="benefitTypeState"
              @update:model-value="onBenefitTypeUpdate"
              option-value="value"
              option-label="name"
              :props="{
                class: '--icon-same q-px-md col-grow',
                size: '15px',
                unelevated: true,
                dense: true
              }"
              :props-active="{
                color: 'secondary'
              }"
              :props-inactive="{
                outline: false,
                color: 'grey-3',
                textColor: 'black'
              }"
              :options="benefitTypesComputed"
              class="flex q-gutter-x-md no-wrap"
          />
        </div>
      </ScrollHorizontal>

      <q-tab-panels
          v-model="benefitTypeState"
          class="c-tab-panels  q-mb-sm"
      >

        <q-tab-panel name="prize" class="c-tab" v-if="userPrizeElement">
          <div class="c-tab-content flex justify-center">
            <FortunePrize
                :prize="userPrizeElement"
                class="c-prize bg-white"
                style="max-width: 150px;"
            />
          </div>
        </q-tab-panel>

        <q-tab-panel name="discount" v-if="discountBenefitsStandaloneBest" class="c-tab">

          <div class="c-tab-content">
            <div class="s-font-sm q-mb-sm">
              Будет использована скидка:
            </div>
            <div class="flex q-gutter-sm s-font-lg">
              <div>
                {{ discountBenefitsStandaloneBest.rule.NAME }}
              </div>
              <div class="text-weight-bold">
                {{ discountBenefitsStandaloneBest.DISCOUNT_PERCENT }} %
              </div>
            </div>
          </div>

        </q-tab-panel>

        <q-tab-panel name="bonus" class="c-tab">
          <div class="c-tab-content q-px-md q-py-sm">
            <div v-if="useBonusesError" class="text-center s-font-sm">
              {{ useBonusesError }}
            </div>
            <template v-else>
              <div class="row q-col-gutter-md">
                <div class="col-6">
                  <q-input
                      :model-value="bonusesState"
                      @update:model-value="onBonusUpdate"
                      mask="#"
                      reverse-fill-mask
                      input-class="s-font-xl text-weight-bold text-grey-8"
                      outlined
                      bg-color="white"
                  >
                    <template #append>

                    </template>
                  </q-input>
                </div>
                <div class="col-18">
                  <div class="swipe-disable q-px-sm">
                    <q-slider
                        :model-value="bonusesState"
                        @update:model-value="onBonusUpdate"
                        :max="bonusesMax"
                        :min="0"
                        :marker-labels="bonusMarkers"
                        switch-label-side
                        class="q-mt-md"
                    />
                  </div>
                </div>
              </div>
            </template>
          </div>
        </q-tab-panel>

        <q-tab-panel name="coupon" class="c-tab">
          <div class="c-tab-content">
            <!-- Текущий купон -->

            <div v-if="coupon" class="coupon-current">

              <div class="flex">
                <div class="coupon-current__name s-font-xl text-weight-bold">
                  {{ coupon.NAME }}
                </div>

                <div class="q-ml-auto">
                  <q-btn
                      dense
                      flat
                      :icon="ICONS.trush"
                      label="удалить"
                      color="red"
                      @click="removeCoupon"
                      :loading="couponMutation.loading.value"
                  />
                </div>
              </div>

              <!-- Товар привязанный к промокоду -->
              <div v-if="couponProduct" class="coupon-product">
                <div class="coupon-product__label text-caption text-grey-7">
                  Товар по промокоду:
                </div>
                <div class="coupon-product__card">
                  <q-img
                      v-if="couponProduct.PREVIEW_PICTURE?.SRC"
                      :src="couponProduct.PREVIEW_PICTURE.SRC"
                      :ratio="1"
                      class="coupon-product__image"
                  />
                  <div class="coupon-product__info">
                    <div class="coupon-product__name text-body2">
                      {{ couponProduct.NAME }}
                    </div>
                    <div v-if="couponProduct.PRICE?.PRICE"
                         class="coupon-product__price text-body1 text-primary text-weight-bold">
                      {{ formatPrice(couponProduct.PRICE.PRICE) }} ₽
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Форма ввода промокода -->
            <div v-else class="coupon-form">
              <q-input
                  v-model="couponCode"
                  outlined
                  label="Введите промокод"
                  :error="!!couponErrorMessage"
                  :error-message="couponErrorMessage"
                  @keyup.enter="applyCoupon"
                  :loading="couponMutation.loading.value"
                  bg-color="white"
              >
                <template #prepend>
                  <q-icon :name="ICONS.promocode"/>
                </template>
              </q-input>

              <div class="coupon-form__hint text-caption text-grey-7 q-mt-sm">
                Введите промокод для получения скидки или подарка
              </div>
            </div>
          </div>
        </q-tab-panel>

      </q-tab-panels>
    </div>


  </StackItemModal>
</template>
<script setup lang="ts">
import {ICONS} from "@/assets/icons";
import FortunePrize from "@/components/Fortune/Prize.vue";
import ButtonsToggle from "@/components/Ui/ButtonsToggle.vue";
import {useGraphql} from "@/core/graphql/service";
import toInt from "@/core/util/toInt";
import {BenefitTypeEnum, MenuItem} from "@/gql/gen";
import {vorderCouponMutation} from "@/gql/gen/mutation/vorderCouponMutation";
import {useFortuneStore} from "@/modules/fortune/store/fortune";
import {useBasketStore} from "@/modules/shop/store/basket";
import {useCatalogStore} from "@/modules/shop/store/catalog";
import {useCurrency} from "@/modules/shop/store/currency";
import {useVorderApi} from "@/modules/shop/store/vorder-api";
import {useVorderState} from "@/modules/shop/store/vorder-state";
import {useVorderTotalStore} from "@/modules/shop/store/vorder-total";
import {useStackComponent} from "@/packages/stack-router/hooks/useStackComponent";
import {storeToRefs} from "pinia";
import plural from "plural-ru";
import {computed, onMounted, ref, toRefs} from "vue";
import {useVorderDialog, VOrderDialogProps, vorderDialogPropsDefault} from "./hook";
import {useBasketRulesStore} from "@/modules/shop/store/basket-rules";
import {useBenefitTypes} from "@/modules/shop/composable/useBenefitTypes";
import {useVorderCoupon} from "@/modules/shop/store/vorder-coupon";
import ScrollHorizontal from "@/components/Ui/ScrollHorizontal.vue";
import {QResizeObserverProps} from "quasar";
import {useYandexMetrikaStore} from "@/modules/yandex/store/metrika";

const vorderState = useVorderState()
const basketStore = useBasketStore()
const totalStore = useVorderTotalStore()
const fortuneStore = useFortuneStore()
const catalogStore = useCatalogStore()
const vorderApi = useVorderApi()
const currencyStore = useCurrency()
const graphqlStore = useGraphql()
const basketRulesStore = useBasketRulesStore()
const vorderCoupon = useVorderCoupon()


const {syncCouponId, removeCouponLocal} = useVorderCoupon()

const {responseSelection, useMutation} = graphqlStore
const {formatPrice} = currencyStore

const {canSetBenefitType, ensureBenefitType} = basketRulesStore

const {bonusesMax, pricePay} = storeToRefs(totalStore)
const {userPrizeElement} = storeToRefs(fortuneStore)
const {vorderInput} = storeToRefs(vorderApi)
const {productsById} = storeToRefs(catalogStore)
const {benefitTypes} = useBenefitTypes()

const {
  attrs,
  bonuses,
  coupon,
  benefitType
} = storeToRefs(vorderState)

const {
  basketIsEmpty
} = storeToRefs(basketStore)

const {
  discountBenefitsStandaloneBest
} = storeToRefs(basketRulesStore)


const props = withDefaults(defineProps<VOrderDialogProps & {
  openBenefitType: BenefitTypeEnum
}>(), {
  ...vorderDialogPropsDefault,
})

const {} = props
const {openBenefitType} = toRefs(props)

const stackComponent = useStackComponent(props)
const {stackItem} = stackComponent

const benefitTypeState = ref(openBenefitType.value || benefitType.value)
const bonusesState = ref(bonuses.value)

const {
  listeners
} = useVorderDialog(props)

const bonusesPercent = computed(() => {
  return Math.round((bonusesState.value / bonusesMax.value) * 100)
})

const benefitTypesComputed = computed(() => {
  return benefitTypes.value.map(item => ({
    name: item.nameTab,
    value: item.value,
    icon: ICONS[item.icon as keyof typeof ICONS] ? ICONS[item.icon as keyof typeof ICONS] : item.icon
  }))
})

const onBenefitTypeUpdate = (val: BenefitTypeEnum) => {
  benefitTypeState.value = val
  attrs.value.BENEFIT_TYPE = val
}

const onBonusUpdate = (val: string | number | null) => {
  const num = toInt(val)
  bonusesState.value = num
  attrs.value.BONUSES = num
}

const useBonusesError = computed(() => {
  if (basketIsEmpty.value) {
    return 'Корзина заказа пуста'
  } else if (!bonusesMax.value) {
    return 'У вас пока нет бонусов'
  }
})

const bonusMarkers = computed(() => {
  const res: any = [
    {value: 0, label: '0'},
  ]
  if (bonusesPercent.value < 94 || true) {
    res.push({value: bonusesMax.value, label: bonusesMax.value},)
  }
  return res
})

const bonusesSuffix = computed(() => bonusesState.value ? plural(bonusesState.value, 'бонус', 'бонуса', 'бонусов') : null)

// Coupon state
const couponCode = ref('')
const couponErrorMessage = ref('')

// Coupon product
const couponProduct = computed(() => {
  if (!coupon.value?.PRODUCT_ID) return null
  return productsById.value[coupon.value.PRODUCT_ID] || null
})

// Coupon mutation
const couponMutation = useMutation(vorderCouponMutation({
  ...responseSelection(),
  payload: {
    coupon: {
      __fragment: 'CouponFields'
    },
    vorder: {
      __fragment: "VorderCurrentFields",
    }
  }
}))

const {triggerGoal} = useYandexMetrikaStore()


// Apply coupon
const applyCoupon = async () => {

  console.log('applyCoupon')
  if (!couponCode.value.trim()) {
    couponErrorMessage.value = 'Введите промокод'
    return
  }

  couponErrorMessage.value = ''

  try {
    const result = await couponMutation.mutate({
      action: 'apply',
      couponCode: couponCode.value.trim(),
      order: vorderInput.value,
      orderPrice: pricePay.value
    })

    if (result?.success && result.payload?.coupon) {
      // Update coupon in state
      coupon.value = result.payload.coupon

      // Sync COUPON_ID
      syncCouponId()

      // Clear input
      couponCode.value = ''
      couponErrorMessage.value = ''

      triggerGoal('promo-lk')
    } else if (result?.error) {
      couponErrorMessage.value = result.error.message || 'Промокод не найден'
    }
  } catch (error) {
    console.error('Error applying coupon:', error)
    couponErrorMessage.value = 'Ошибка при применении промокода'
  }
}

// Remove coupon
const removeCoupon = async () => {

  try {
    removeCouponLocal()
    couponCode.value = ''
    couponErrorMessage.value = ''

    const result = await couponMutation.mutate({
      action: 'remove',
      couponCode: '',
      order: vorderInput.value
    })
  } catch (error) {
    console.error('Error removing coupon:', error)
  }
}

const onApply = () => {
  stackItem?.close()
}

const actions = computed(() => {
  const res: Partial<MenuItem>[] = []

  let closeLabel: string | boolean = 'Готово'

  switch (benefitTypeState.value) {
    case 'bonus':
      if (bonusesMax.value && (bonusesState.value < bonusesMax.value)) {
        res.push({
          label: 'Использовать ' + bonusesMax.value + ' бонусов',
          flat: true,
          onClick: () => onBonusUpdate(bonusesMax.value),
        })
      }
      if (!useBonusesError.value) {
        closeLabel = 'Применить'
      }
      break;

    case 'coupon':
      if (coupon.value) {

      } else {
        if (couponCode.value.trim()) {
          res.push({
            label: 'Применить',
            color: 'primary',
            onClick: applyCoupon,
            loading: !!couponMutation.loading.value
          })
          closeLabel = false
        }
      }
      break;
  }

  if (closeLabel) {
    res.push({
      label: closeLabel,
      onClick: onApply,
      // outline: true
    })
  }

  return res
})

onMounted(() => {
  if (canSetBenefitType(openBenefitType.value)) {
    ensureBenefitType(openBenefitType.value)
  }
})

const onHide = () => {
  ensureBenefitType(benefitTypeState.value)
}


const dialogTitle = computed(() => {
  switch (benefitTypeState.value) {
    case 'bonus':
      return 'Использовать бонусы'
    case 'discount':
      return 'Использовать скидку'
    case 'prize':
      return 'Использовать приз'
    case 'coupon':
      return 'Использовать промокод'
    default:
      return 'выберите';
  }
})


const width = ref(0)

const onResize: QResizeObserverProps['onResize'] = (size) => {
  width.value = size.width
}

</script>
<style scoped>

.c-tab {
  padding: 0;
}

.c-tab-panels,
.c-tab-panels :deep(.q-panel) {
  overflow: visible !important;
}

.c-tab-content {
  margin: 0 6px 0 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background-color1: rgba(48, 85, 100, 0.10);
  border-radius: 10px;
  padding: 14px;
}

/* Coupon styles */
.coupon-current {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.coupon-current__main {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  color: white;
}

.coupon-current__info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.coupon-current__code {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 2px;
}

.coupon-current__name {
  opacity: 0.9;
}

.coupon-product {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.coupon-product__label {
  font-weight: 500;
}

.coupon-product__card {
  display: flex;
  gap: 12px;
  padding: 12px;
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.coupon-product__image {
  width: 60px;
  height: 60px;
  border-radius: 6px;
  flex-shrink: 0;
}

.coupon-product__info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.coupon-product__name {
  line-height: 1.3;
}

.coupon-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.coupon-form__hint {
  padding: 0 4px;
}

</style>
